import { Component, Input, Host, ElementRef, EventEmitter, Output, AfterContentInit } from "@angular/core";
import {AccordionComponent} from './accordion.component';
import '../../../styles/bootstrap/bootstrap';
const $ = require('jquery');

@Component({
    selector: 'accordion-group',
    template: require('./accordion.group.template.html')
})
export class AccordionGroupComponent implements AfterContentInit {

    @Output()
    onToggle:EventEmitter<boolean> = new EventEmitter<boolean>();

    //todo andrey implement heading
    @Input('heading')
    heading:string;

    @Input('is-opened')
    isOpened:boolean = false;

    private bodyEl:any;

    private accordionAnimationInProgress : boolean = false;

    constructor(@Host() public accordion:AccordionComponent, private element:ElementRef) {
    }

    ngAfterContentInit() {
        this.bodyEl = $(this.element.nativeElement).find('.panel-collapse');
        this.accordion.registerGroup(this);
        this.bodyEl.on('show.bs.collapse', () => this.animationProcessingStarted());
        this.bodyEl.on('hide.bs.collapse', () => this.animationProcessingStarted());
        this.bodyEl.on('shown.bs.collapse', () => this.animationProcessingStopped());
        this.bodyEl.on('hidden.bs.collapse', () => this.animationProcessingStopped());
    }

    toggle() {
        if (!this.accordionAnimationInProgress) {
            this.accordion.selectGroup(this);
            this.onToggle.emit(this.isOpened);
        }
    }

    close() {
        if (this.isOpened) {
            this.toggle();
        }
    }

    open() {
        if (!this.isOpened) {
            this.toggle();
        }
    }

    updateView() {
        this.bodyEl.collapse(this.isOpened ? 'show' : 'hide');
    }

    private animationProcessingStarted() {
        this.accordionAnimationInProgress = true;
    }

    private animationProcessingStopped() {
        this.accordionAnimationInProgress = false;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/accordion/accordion.group.component.ts